import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './utils/auth';
import { WebSocketProvider } from './utils/WebSocketContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import TasksPage from './pages/TasksPage';
import NewTaskPage from './pages/NewTaskPage';
import TaskDetailPage from './pages/TaskDetailPage';
import TaskEditPage from './pages/TaskEditPage';
import KnowledgeBasesPage from './pages/KnowledgeBasesPage';
import NewKnowledgeBasePage from './pages/NewKnowledgeBasePage';
import KnowledgeBaseDetailPage from './pages/KnowledgeBaseDetailPage';
import KBTagsPage from './pages/KBTagsPage';
import TaskTagsPage from './pages/TaskTagsPage';
import ProjectTagsPage from './pages/ProjectTagsPage';
import ProjectsPage from './pages/ProjectsPage';
import NewProjectPage from './pages/NewProjectPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import FilePreview from './components/FilePreview';
import KBResourcePreview from './components/KBResourcePreview';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks"
          element={
            <ProtectedRoute>
              <TasksPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks/new"
          element={
            <ProtectedRoute>
              <NewTaskPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks/:id/edit"
          element={
            <ProtectedRoute>
              <TaskEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks/:id"
          element={
            <ProtectedRoute>
              <TaskDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/knowledge-bases"
          element={
            <ProtectedRoute>
              <KnowledgeBasesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/knowledge-bases/new"
          element={
            <ProtectedRoute>
              <NewKnowledgeBasePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/knowledge-bases/:id"
          element={
            <ProtectedRoute>
              <KnowledgeBaseDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kb-tags"
          element={
            <ProtectedRoute>
              <KBTagsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/task-tags"
          element={
            <ProtectedRoute>
              <TaskTagsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project-tags"
          element={
            <ProtectedRoute>
              <ProjectTagsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <ProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/new"
          element={
            <ProtectedRoute>
              <NewProjectPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:id"
          element={
            <ProtectedRoute>
              <ProjectDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks/:taskId/files/:fileId/preview"
          element={
            <ProtectedRoute>
              <FilePreview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/knowledge-bases/:kbId/resources/:resourceId/preview"
          element={
            <ProtectedRoute>
              <KBResourcePreview />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      </WebSocketProvider>
    </AuthProvider>
  );
}

export default App;
